import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CATALOG_EMPTY_STATE_TRANSLATION_KEY } from "../constants";
var es = /*#__PURE__*/_defineProperty({}, CATALOG_EMPTY_STATE_TRANSLATION_KEY, {
  CATALOG_EMPTY_STATE_CHIP_ALL: 'Todos',
  CATALOG_EMPTY_STATE_TITLE: '¿Qué deseas ver?',
  CATALOG_EMPTY_STATE_GO_TO_CATALOG: 'Ir al catálogo',
  CATALOG_EMPTY_STATE_STUDY_PLAN_TITLE: 'Aún no creas tu plan de estudios',
  CATALOG_EMPTY_STATE_STUDY_PLAN_DESCRIPTION: 'Organiza tu semana para alcanzar tus objetivos de aprendizaje.',
  CATALOG_EMPTY_STATE_STUDY_PLAN_BUTTON: 'Crear plan de estudios',
  CATALOG_EMPTY_STATE_COURSES_TITLE: 'Cursos de {{name}}',
  CATALOG_EMPTY_STATE_SHOW_MORE: 'Ver cursos filtrados',
  CATALOG_EMPTY_STATE_COURSE_CARD_CTA: 'Ver detalle'
});
export default es;